import { UPDATE_TITLE } from './constants'

const initialState = { title: 'Home Page' }

export default function breadcrumbsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TITLE: {
      return {
        ...state,
        title: action.title
      }
    }
    default: {
      return state
    }
  }
}
